import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { IDeleteEntity, IGenericResponse } from '../shared';
import { LoggingService } from '../shared/services/logging/logging.service';

@Injectable({
    providedIn: 'root'
})
export class InternalAdminService {
    constructor(private http: HttpClient, private log: LoggingService) {}

    private juri = `${environment.apiLocation}/Jobs`;
    private ecuri = `${environment.apiLocation}/eFAACTCustomer`;
    private qjuri = `${environment.apiLocation}/QueueJob`;
    private tloUri = `${environment.apiLocation}/TraceLoggingOverride`;

    public geteFAACTCustomers(): Observable<any> {
        this.log.verbose({
            type: 'InternalAdminService:geteFAACTCustomers',
            uri: this.ecuri
        });
        return this.http.get<any>(this.ecuri).pipe(
            tap(res =>
                this.log.verbose({
                    type: 'InternalAdminService:response',
                    res
                })
            )
        );
    }

    public getJobs(): Observable<any> {
        this.log.verbose({
            type: 'InternalAdminService:getJobs',
            uri: this.juri
        });
        return this.http.get<any>(this.juri).pipe(
            tap(res =>
                this.log.verbose({
                    type: 'InternalAdminService:response',
                    res
                })
            )
        );
    }

    public postQueueJob(
        employeelistid: string,
        customerid: string,
        jobid: string,
        storedproc?: string
    ): Observable<any> {
        this.log.verbose({
            type: 'InternalAdminService:postQueueJob',
            uri: this.qjuri
        });
        return this.http
            .post<any>(this.qjuri, {
                employeelistid: employeelistid,
                customerid: customerid,
                jobid: jobid,
                storedproc: storedproc
            })
            .pipe(
                tap(res =>
                    this.log.verbose({
                        type: 'InternalAdminService:response',
                        res
                    })
                )
            );
    }

    public getTraceLoggingOverrides(): Observable<string> {
        this.log.verbose({
            type: 'InternalAdminService:getTraceLoggingOverrides',
            uri: this.tloUri
        });
        return this.http.get(this.tloUri, { responseType: 'text' }).pipe(
            tap(res =>
                this.log.verbose({
                    type: 'InternalAdminService:response',
                    res
                })
            )
        );
    }

    public postTraceLoggingOverride(body: {
        customerId?: number;
        loginName?: string;
        minLogLevel: string;
        logTargets?: string;
        enabled: boolean;
        expiresUtc?: string;
        notes?: string;
    }): Observable<string> {
        return this.http.post(this.tloUri, body, { responseType: 'text' }).pipe(
            tap(res =>
                this.log.verbose({
                    type: 'InternalAdminService:postTraceLoggingOverride',
                    res
                })
            )
        );
    }

    public putTraceLoggingOverride(body: {
        traceLoggingOverrideId: number;
        customerId?: number;
        loginName?: string;
        minLogLevel?: string;
        logTargets?: string;
        enabled?: boolean;
        expiresUtc?: string;
        notes?: string;
    }): Observable<string> {
        return this.http.put(this.tloUri, body, { responseType: 'text' }).pipe(
            tap(res =>
                this.log.verbose({
                    type: 'InternalAdminService:putTraceLoggingOverride',
                    res
                })
            )
        );
    }

    // public put(jsonstring: string): Observable<any> {
    //     return this.http
    //         .put<any>(this.uri, {
    //             JsonString: jsonstring
    //         })
    //         .pipe(
    //             tap(data =>
    //                 this.log.verbose({
    //                     type: 'CompanyInfoService:put',
    //                     data
    //                 })
    //             )
    //         );
    // }
}
